<script lang="ts">
import { useEpciCommuneStore, useOnlineStore, useUserStore } from "../../store"

export default {
    name: "MenuUserProfile",
    setup() {
        const access_token = useCookie<string>("access_token")
        const config = useRuntimeConfig()
        const userStore = useUserStore()
        const onlineStore = useOnlineStore()
        const epciCommuneStore = useEpciCommuneStore()
        return {
            access_token,
            config,
            userStore,
            onlineStore,
            epciCommuneStore,
        }
    },
    data: () => ({
        menu: false,
        message: false,
    }),
    computed: {
        isCurrentUserAdmin(): boolean {
            return this.userStore?.currentUser?.role === "admin"
        },
    },
    mounted() {
    },
    methods: {
        save() {
            this.menu = false
        },
        async logout() {
            this.epciCommuneStore.setSelectedEpciCommune(null)
            this.userStore.setUser({})
            await this.$api.setRequest({
                url: "logout",
                method: "POST",
            })
            await this.$router.push("/")
            await this.userStore.clearUser()
        },
    },
}
</script>

<template>
    <div>
        <client-only>
            <div v-if="$currentUser()?.k">
                <v-menu v-if="onlineStore.online" v-model="menu" :close-on-content-click="false" location="end">
                    <template #activator="{ props }">
                        <v-btn color="primary" icon v-bind="props" class="mr-2 border">
                            <strong>{{ $currentUser().first_name[0] }}{{ $currentUser().last_name[0] }}</strong>
                        </v-btn>
                    </template>

                    <v-card min-width="300">
                        <v-card-title class="d-flex justify-space-around border-b">
                            {{ $currentUser().first_name }}
                            {{ $currentUser().last_name }}
                        </v-card-title>
                        <v-card-text class="d-flex flex-column ga-2">
                            <div class="d-flex justify-space-around align-center py-2">
                                <p class="text-caption mt-1">
                                    <v-icon size="x-small" class="mr-3">
                                        mdi-email-outline
                                    </v-icon>
                                    {{ $currentUser().email }}
                                </p>
                                <v-chip
                                    size="x-small"
                                    :color="$getColor(`utilisateurs.role.${$currentUser().role}`)"
                                >
                                    {{ $translate(`utilisateurs.role.${$currentUser().role}`) }}
                                </v-chip>
                            </div>
                            <v-btn
                                v-if="$permissionCheck('profile_show')"
                                append-icon="mdi-account"
                                color="primary"
                                block
                                to="/profil"
                                @click="menu = false"
                            >
                                Mon profil
                            </v-btn>
                            <v-btn append-icon="mdi-logout" color="danger" block @click="logout">
                                Se déconnecter
                            </v-btn>
                        </v-card-text>
                    </v-card>
                </v-menu>
                <v-btn v-else class="mr-2">
                    <strong>{{ $currentUser().first_name[0] }}{{ $currentUser().last_name[0] }}</strong>
                </v-btn>
            </div>
        </client-only>
    </div>
</template>
